import styled from "styled-components";

import { Td } from "src/organization/pages/project/environment/metrics/components/tooltip/style";

export const TdTitle = styled(Td)`
  color: var(--theme-neutral-400);
`;

export const TdKey = styled(Td)`
  min-width: 10px;
`;
